<script lang="ts">
    import {createEventDispatcher} from "svelte";
    import ContactPersonBox from "../form/ContactPersonBox.svelte";
    import ErrorBox from "../form/ErrorBox.svelte";
    import {entityStore, myStore} from "../../stores.js";
    import { getContext } from 'svelte';
    import RadioBtn from "../form/RadioBtn.svelte";
    import UploadInfoBox from "../form/UploadInfoBox.svelte";
    import FileUploadBtn from "../form/FileUploadBtn.svelte";


    const dispatch = createEventDispatcher();
    const validateStep = getContext('validateStep');

    let submitted:Boolean = false;
    let validStep = null;
    const stepKey = "step1";


    /*
    function onSubmitBtnClicked(){
       dispatch('submitBtnClicked');
    }

     */

    function checkValidity(key){
        let steps =  $entityStore.steps;
      const index = steps.findIndex((s) => s.key == key)
        if(steps[index]){
           validStep = steps[index].valid; // !step.valid && step.touched;

            steps[index].touched = true;

            if(validStep){
                //open next accordion
                if(index < steps.length){
                    steps[index].expanded = false;
                    steps[index].isActive = false;
                    steps[index].disabled = false;

                    steps[index+1].disabled = false;
                    steps[index+1].isActive = true;
                    steps[index+1].expanded = true;


                }

            }

            entityStore.update($entityStore => ({
                ...$entityStore,
                steps
            }));
        }
    }

    function validateCurrentStep(){
        submitted = true;
        //validateStep(stepKey);
        checkValidity(stepKey)

        console.log("steps after: ",$entityStore.steps);
    }


</script>
<!-- translation example: {$_('introText')}-->
<div class="step">

<div class="person-wrapper" >
    <!-- new:
    <ContactPersonBox title="Personne de contact 1" index={0} formGroupName="firstPactPerson"></ContactPersonBox>
    <ContactPersonBox title="Personne de contact 2" index={1} formGroupName="secondPactPerson"></ContactPersonBox>
-->
    <ContactPersonBox title="Personne de contact 1" index={0} formGroupName="firstPactPerson"></ContactPersonBox>
    <ContactPersonBox title="Personne de contact 2" index={1} formGroupName="secondPactPerson"></ContactPersonBox>
</div>
    <!--
    {JSON.stringify( $myStore.errors.step1, null, 2)}
    {#if $myStore.errors.step1.firstPactPerson}
        {$myStore.errors.step1.firstPactPerson.toString()}
     -->
    {#if submitted && !validStep}
        <ErrorBox>Les champs avec un cadre rouge ne sont pas encore remplis ou sont erronés.</ErrorBox>
    {/if}
    {#if !submitted || !validStep}
    <div class="step-validation-btn" style="margin-top:1rem;">
        <button class="mt-2 btn btn-brand submitBtn" on:click={validateCurrentStep}>continuer</button>

    </div>
    {/if}

</div>


<style lang="scss">

    .person-wrapper{

      display:flex;
      gap:2rem;
      flex-wrap:nowrap;
    }


</style>
